var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.install
    ? _c("div", [
        _c("div", { staticClass: "mb-4" }, [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("FINISH_SCREEN.REDIRECT_MESSAGE")) +
              "\n    "
          ),
          _c(
            "a",
            {
              staticClass: "underline",
              attrs: {
                href: _vm.link,
                "aria-label": _vm.$t("A11Y.DOWNLOAD_APP"),
                rel: "noopener",
                target: "_blank"
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("FINISH_SCREEN.REDIRECT_LINK")) +
                  "\n    "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _vm.install && _vm.os === "ios"
          ? _c(
              "div",
              [
                _c("div", { staticClass: "mb-4" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("FINISH_SCREEN.DOWNLOAD_APP")) +
                      "\n    "
                  )
                ]),
                _vm._v(" "),
                _c("app-store-icon")
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.install && _vm.os === "android"
          ? _c(
              "div",
              [
                _c("div", { staticClass: "mb-4" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("FINISH_SCREEN.DOWNLOAD_APP")) +
                      "\n    "
                  )
                ]),
                _vm._v(" "),
                _c("play-store-icon")
              ],
              1
            )
          : _vm._e()
      ])
    : _c(
        "div",
        [
          _c("div", { staticClass: "mb-4" }, [
            _vm._v(
              "\n    " + _vm._s(_vm.$t("FINISH_SCREEN.COPY_MESSAGE")) + "\n  "
            )
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "underline mb-6 block truncate",
              attrs: {
                href: _vm.feed,
                rel: "noopener",
                "aria-label": _vm.$t("A11Y.FEED"),
                target: "_blank"
              }
            },
            [_vm._v("\n    " + _vm._s(_vm.feed) + "\n  ")]
          ),
          _vm._v(" "),
          _c(
            "tooltip",
            {
              attrs: {
                trigger: "click",
                content: _vm.$t("MESSAGES.COPIED"),
                color: _vm.alt,
                background: _vm.color,
                placement: "top"
              },
              on: { click: _vm.copyLink }
            },
            [
              _c(
                "button",
                {
                  staticClass: "py-2 px-4 rounded-sm text-sm",
                  style: Object.assign(
                    {},
                    { background: _vm.color, color: _vm.alt },
                    _vm.font
                  ),
                  attrs: { title: _vm.$t("A11Y.COPY_FEED") }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("FINISH_SCREEN.COPY_URL")) +
                      "\n    "
                  )
                ]
              )
            ]
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }